import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/i18n";

const links = [
  { to: "/", key: "inicio" },
  { to: "/catalogo", key: "catalogo" },
  { to: "/disena", key: "disena" },
  { to: "/proceso", key: "proceso" },
];

export const Nav = () => {
  const { t, lang, setLang, currency, setCurrency } = useLang();
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#F7F5F0]/80 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-serif-d text-xl md:text-2xl font-semibold text-[#132A1D] tracking-tight">
          Miss Pam <span className="italic text-[#C86A4B]">Transforma</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-link-${l.key}`}
              className={`text-sm font-medium transition-colors duration-200 hover:text-[#C86A4B] ${loc.pathname === l.to ? "text-[#2E5A3B]" : "text-[#5C5C5C]"}`}>
              {t.nav[l.key]}
            </Link>
          ))}
          <a href="/juegos/" data-testid="nav-link-juegos" className="text-sm font-medium text-[#5C5C5C] hover:text-[#C86A4B] transition-colors duration-200">
            {t.nav.juegos}
          </a>
          <Link to="/contacto" data-testid="nav-link-contacto"
            className={`text-sm font-medium transition-colors duration-200 hover:text-[#C86A4B] ${loc.pathname === "/contacto" ? "text-[#2E5A3B]" : "text-[#5C5C5C]"}`}>
            {t.nav.contacto}
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <button data-testid="currency-toggle" onClick={() => setCurrency(currency === "cop" ? "usd" : "cop")}
            className="text-xs font-bold px-3 py-1.5 rounded-full border border-black/10 text-[#2E5A3B] hover:bg-[#2E5A3B] hover:text-white transition-colors duration-200 uppercase">
            {currency}
          </button>
          <button data-testid="lang-toggle" onClick={() => setLang(lang === "es" ? "en" : "es")}
            className="text-xs font-bold px-3 py-1.5 rounded-full bg-[#2E5A3B] text-white hover:bg-[#C86A4B] transition-colors duration-200 uppercase">
            {lang === "es" ? "EN" : "ES"}
          </button>
          <button data-testid="mobile-menu-btn" className="md:hidden p-2" onClick={() => setOpen(!open)}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }}
            className="md:hidden overflow-hidden bg-[#F7F5F0] border-t border-black/5">
            <div className="px-5 py-4 flex flex-col gap-4">
              {links.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.key}`}
                  className="text-base font-medium text-[#132A1D]">{t.nav[l.key]}</Link>
              ))}
              <a href="/juegos/" data-testid="mobile-nav-juegos" className="text-base font-medium text-[#132A1D]">{t.nav.juegos}</a>
              <Link to="/contacto" onClick={() => setOpen(false)} data-testid="mobile-nav-contacto" className="text-base font-medium text-[#132A1D]">{t.nav.contacto}</Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
